'use client';

import { ReactNode, memo } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { CardBanner, CardBannerProps } from './CardBanner';

interface GenericBannerProps extends CardBannerProps {
    children: ReactNode;
    classNames?: {
        container?: string;
        imgWrapper?: string;
        cta?: string;
    };
}

/**
 * GenericBanner component is a reusable intermediate component for rendering banners.
 *
 * @param {GenericBannerProps} props - The properties for the GenericBanner component.
 */
export const GenericCard: ComponentMemo<GenericBannerProps> = memo(
    ({ image, children, classNames, ...props }: GenericBannerProps) => {
        return (
            <CardBanner
                classNames={{
                    container: clsx(
                        'flex flex-1 flex-row items-start',
                        'border-border-primary border-medium border-solid rounded-0.5',
                        'h-auto',
                        'bg-background-l2',
                        classNames?.container,
                    ),
                }}
                image={{
                    ...image,
                    classNames: {
                        wrapper: clsx('object-cover overflow-hidden flex', classNames?.imgWrapper),
                        cta: clsx('h-full', classNames?.cta),
                        image: 'w-full object-cover',
                    },
                }}
                {...props}
            >
                {children}
            </CardBanner>
        );
    },
);

GenericCard.displayName = 'GenericCard';
